module.exports = __webpack_public_path__ + "static/media/startupx1.6dbd5b29.jpeg";